import { render, staticRenderFns } from "./detailAccount.vue?vue&type=template&id=98ea3934&scoped=true&"
import script from "./detailAccount.vue?vue&type=script&lang=js&"
export * from "./detailAccount.vue?vue&type=script&lang=js&"
import style0 from "./detailAccount.vue?vue&type=style&index=0&id=98ea3934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ea3934",
  null
  
)

export default component.exports